import config from "../../config";

// export const base_url = "http://192.168.18.178:8000/api/";
// export const temp_url = "http://192.168.18.178:8000/api/";

// export const base_url = "http://192.168.18.181:8000/api/";
// export const temp_url = "http://192.168.18.181:8000/api/";

// export const base_url = "https://fixedasset.alisonstech-dev.com/api/";
// export const temp_url = "https://fixedasset.alisonstech-dev.com/api/";

export const base_url = "https://fixedasset.staging.alisonstech-dev.com/Admin/api/";
export const temp_url = "https://fixedasset.staging.alisonstech-dev.com/Admin/api/";


export const encryptionSecret = config.encryptionSecret;

export const logInApii = "login";
export const loginAuthh = "login";
export const ForgetPassword = "Password/GetOTP";
export const ChangePassword = "User/Password/change";
export const VerifyOTP = "Password/VerifyOTP";
export const registerBrandOwner = "Brand/create";
export const registerRollsApi = "Role/create-role";
export const editRoleAPI = "Role/Update";
export const registerbranduser = "User/register";
export const allUsersApi = "User/get";
export const usersStatusUpdateApi = "User/update";
export const edituserapis = "User/update";
export const allDropdownActiveCompanies = "Company/get/active";
export const allDropdownActiveBrand = "Brand/get/active";
export const registerProduct = "Products/create";
export const allProductApi = "Products/getAll";
export const allProductActiveApi = "Products/get/active";
export const ProductStatusUpdateApi = "Products/update";
export const editProductApi = "Products/u qpdate";
export const updateVerfiyLimit = "Products/updateVerfiyLimit";
export const brandupdatestatusApi = "Brand/update";
export const allRoleApi = "Role/get-roles";
export const assignpermissionsApi = "Permission/assign-permission";
export const getRolePermissionsApi = "Permission/get-rolepermissions";
export const allpermissionsApi = "Permission/get-allpermissions";
export const getAllBrands = "Brand/getAll";
export const brandeditapi = "Brand/get";
export const getsallcategeory = "Category/index";
export const update_status_code = "RandomCodes/update-status";
export const updatestatuscategory = "Category/status-update";
export const cateapplyregister = "Category/store";
export const editingcategory = "Category/update";
export const allsubcategroiess = "SubCategory/index";
export const subcategoryupdatestatus = "SubCategory/status-update";
export const subcategoryEdit = "SubCategory/update";
export const createSubcategory = "SubCategory/store";
export const companygetall = "Company/getAll";
export const createcompany = "Company/register";
export const companystatusupdate = "Company/update";
export const companydetailing = "Company/get";
export const getAllCounts = "Admin/Dashboard";
export const getRandomCodes = "RandomCodes/index";
export const postRandomCodes = "PrePost/store";
export const GetAllBatch = "Batches/getAll";
export const GetBatchId = "Batches/get/";
export const batchStatusUpdate = "Batches/update";
export const batchProductSerialNo = "Batches/Product/availableSerialNo/";
export const postBatchAPI = "Batches/create";
export const postUpdateBatchAPI = "Batches/update";
export const getBatchByProductID = "Batches/getBatchesByProduct/";
export const GetAllcustommBatch = "Batches/custom/getAll";
export const GetAllcustommBatchEx = "Batches/custom/getAll";
export const CustomBatch_API = "Batches/custom/create";
export const postUpdatecustomBatch_API = "Batches/custom/update";
export const postAddCodesBatch_API = "Batches/custom/add";
export const ViewAllcustommBatch_api = "Batches/get/custom/";
export const GetAllCustomer_api = "customer/get";
export const Customer_API = "customer/create";
export const Customer_edit_API = "customer/update";
export const GetActiveCustomer_api = "customer/get/active";
export const activeStatuscustomer_api = "customer/update/";
export const getSms = "sms/get";
export const createSMS = "Replay/store";
export const SmsReport = "Report/sms";
export const QrcodeReport = "Report/qr";
export const MapApi = "Report/qr/map";
export const ReportProblem = "ReportProblem";
export const BatchesGetAll_api = "Batches/both/getAll";
export const smsReply = "Reply/getAll";
export const createsmsReply = "Reply/store";
export const editsmsReply = "Reply/edit";
export const StatusSmsReply = "Reply/update";
export const ColorShift = "getColorShifting";
export const getColorShift = "getColorShiftingWeb";
export const UpdateFAQs = "faqs/update";
export const UpdateTerms = "Terms/update";
export const GetFAQs = "faqs";
export const GETTerms = "Terms";
export const csv_url = "RandomCodes/csv";
export const prepostapii = "prepost/id";
export const getRandomCodesRange = "RandomCodes/range";
export const Fetcrandroutee = "RandomCodes/getDetails";
export const brandownerclientroute = "brand-owners/";



// ==================================================NEW PROJECT================================

export const ProjectsGet_api = "projects";

// Master Data APIs
export const MasterDataBase_api = (projectId, resource) => `projects/${projectId}/master-data/${resource}`;
export const MasterDataById_api = (projectId, resource, id) => `projects/${projectId}/master-data/${resource}/${id}`;
export const MasterDataStatus_api = (projectId, resource, id) => `projects/${projectId}/master-data/${resource}/${id}/status/inactive`;
const mapResourceToListName = (resource) => {
    if (resource === "custom-attributes") return "custom_fields";
    return resource.replace(/-/g, "_");
};

export const MasterDataTemplate_api = (projectId, resource) => `projects/${projectId}/master-data/${mapResourceToListName(resource)}/template`;
export const MasterDataUpload_api = (projectId, resource) => `projects/${projectId}/master-data/${mapResourceToListName(resource)}/upload`;
export const MasterDataReviewQueue_api = (projectId) => `projects/${projectId}/master-data/review-queue`;
export const MasterDataSync_api = (projectId) => `projects/${projectId}/master-data/sync`;

// Dashboard APIs — one generic path builder for all 6 dashboard sections
// (progress | collector-progress | location-progress | quality | status-funnel | map)
export const DashboardSection_api = (projectId, section) => `projects/${projectId}/dashboard/${section}`;

// Project asset hierarchy download — paginated webadmin endpoint.
// page and perPage are forwarded from component state so they are always dynamic.
export const ProjectAssetsDownload_api = (projectId, page = 1, perPage = 10) =>
    `projects/${projectId}/assets/download_webadmin?page=${page}&per_page=${perPage}`;

// Old Tag Numbers APIs
export const OldTagsTemplate_api = (projectId) => `projects/${projectId}/old-tags/template`;
export const OldTagsExport_api = (projectId) => `projects/${projectId}/old-tags/export`;
export const OldTagsImport_api = (projectId) => `projects/${projectId}/old-tags/import`;

// ======================================================NEW PROJECT==========================================